import React, { Component } from 'react';
import ReactDOM from 'react-dom';

//const mySql=require('../mySql/sqlServer');
var config=require('../config');
var request=require('request');
var guiUtils=require('../ApsHtmlGuiUtils');
var md5=require("md5");
var sha256=require("crypto-js/sha256");
//var bcrypt=require('bcryptjs');
//var sql=require("../sqlServer");


class ChangePassword extends Component{
	constructor(props){
		super(props);
		this.state={connRez:[]};
		this.changePassword=this.changePassword.bind(this);

	}

	changePassword(){

		var _u=sessionStorage.getItem("u");
		if(_u==null||_u==""||_u=="none")
		{
			alert("Vous devez être connecté pour changer votre mot de passe");
			return;
		}

		var oldVal=document.getElementById("oldPwdField").value;
		var newVal=document.getElementById("newPwdField").value;
		var newVal2=document.getElementById("newPwdField2").value;

		if(oldVal==""||newVal=="")
		{
			alert("Veuillez remplir tous les champs");
			return;
		}

		if(newVal!=newVal2)
		{
			alert("Les nouveaux mots de passe ne correspondent pas");
			return;
		}

		var _old=sha256(oldVal);
		var _new=sha256(newVal);

		let self=this;
		let str=config.sqlServerAddress()+'/gRaw/changeUserPassword/'
			+
			"'"+_u+"','"+_old+"','"+_new+"'";

			fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}

				return response.json();
			}).then(function(data){
				self.setState({connRez:data[0].result});
			}).catch(err=>{console.log('caught',err);
			});
	}
	componentDidMount()
	{

	}

	render()
	{


		return (<div id="changePwdForm">
		<div class='text' id="userPwdL2">Mot de passe actuel *</div>
		<input class='field' id="oldPwdField" type="password" />
		<div class='text' id="userPwdL2">Nouveau mot de passe *</div>
		<input class='field' id="newPwdField" type="password" />
		<div class='text' id="userPwdL">Nouveau mot de passe (pour v&#233;rification) *</div>
		<input class='field' id="newPwdField2" type="password" />
		<br />
		<input class='field' id="userAddButton" type="button" value="Valider" onClick={this.changePassword} />
		<div class='text' id="userAddResult">{this.state.connRez}</div>

		</div>

		);

		//ReactDom.render(<PartFinderButton />,document.getElementById('_partFinderButton'));
	}
}

export default ChangePassword;
